import { I as l } from "../../constants-DeVuDy8J.js";
import { openBlock as i, createElementBlock as o, normalizeClass as n, createElementVNode as r } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconDownloadCloud",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(l).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return l[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, u = ["aria-label", "data-qa", "aria-hidden"];
function m(e, t, d, _, f, a) {
  return i(), o("svg", {
    "aria-label": d.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--download-cloud"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Download Cloud",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...t[0] || (t[0] = [
    r("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M5.598 2.209a3 3 0 0 0-3.24 4.89.5.5 0 0 1-.715.7A4 4 0 1 1 8.209 3.5h.54a2.75 2.75 0 0 1 1.529 5.037.5.5 0 1 1-.556-.832A1.75 1.75 0 0 0 8.75 4.5h-.895a.5.5 0 0 1-.48-.357A3 3 0 0 0 5.599 2.21Z",
      fill: "currentColor"
    }, null, -1),
    r("path", {
      d: "M6 5.5a.5.5 0 0 1 .5.5v3.293l1.146-1.147a.5.5 0 1 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L5.5 9.293V6a.5.5 0 0 1 .5-.5Z",
      fill: "currentColor"
    }, null, -1)
  ])], 10, u);
}
const w = /* @__PURE__ */ s(c, [["render", m]]);
export {
  w as default
};
//# sourceMappingURL=download-cloud.js.map
